module.exports = __webpack_public_path__ + "img/rank-title.6c040537.svg";